export default "__VITE_ASSET__C56htzE3__"